import { inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@core/utils/base-component';

export abstract class DialogBase<T, R = any> extends BaseComponent {
    public matDialogRef = inject(MatDialogRef<R, T>);

    public canCloseDialog(): boolean {
        return false;
    }

    public onClose(dialogResult?: R): void {
        this.matDialogRef.close(dialogResult);
    }
}
